import { Button, Checkbox, Group, Modal, ModalProps, Text } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { deleteRobot } from '@mygpt/app';
import { useDatasetStore } from '@/store/dataset';

interface Props extends ModalProps {
  name: string;
  id: string;
  isCloning: boolean;
}

export default (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setCloningTipOpened } = useDatasetStore();

  const { id, isCloning, name, ...rest } = props;
  const [loading, setLoading] = useState(false);

  const [checked, setChecked] = useState(false);

  const deleteRobotMethod = async () => {
    if (checked && isCloning) {
      setCloningTipOpened(true);
      return;
    }
    setLoading(true);
    deleteRobot({ aiId: id, deleteDataset: checked })
      .then(() => {
        navigate(`/`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal {...rest} size={'auto'}>
      <div className="py-5">
        <span
          dangerouslySetInnerHTML={{
            __html: t('embeddings.chatbot.delete.text', { name }),
          }}
        />
        <Checkbox
          mt={25}
          size="md"
          label={t('embeddings.chatbot.delete.delete_data')}
          checked={checked}
          onChange={(event) => setChecked(event.currentTarget.checked)}
        />
      </div>
      <Group justify="space-between" wrap="nowrap" mt={30}>
        <Text color={'red.5'} size={'sm'}>
          {t('embeddings.chatbot.delete.warning')}
        </Text>
        <Group wrap="nowrap" ml={20}>
          <Button variant="outline" disabled={loading} onClick={props.onClose}>
            {t('alert_cancel')}
          </Button>
          <Button loading={loading} color="red" onClick={deleteRobotMethod}>
            {t('delete_btn')}
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
